export function CeleroTokenizerDirective () {
  return {
    controller: 'CeleroTokenizerCtrl',
    restrict: 'E',
    scope: {
      invoice: '=',
      payment: '='
    },
    template: '<div id="tokenizer"></div>'
  };
}
